import { useEffect } from 'react';
import type { IScreensLogging } from 'shared/src/api/types';
import { bridge } from 'shared/src/utils';
import type { LogAnalyticsEventParams } from 'shared/src/utils/bridge/logAnalyticsEvent/types';

type UseLogViewEventProps = {
  logging?: IScreensLogging;
  screenName?: string;
};

export const useLogViewEvent = ({
  logging,
  screenName,
}: UseLogViewEventProps) => {
  useEffect(() => {
    if (!logging || !screenName) {
      return;
    }
    bridge.logAnalyticsEvent({
      name: `VIEW_${screenName}`,
      analytics: logging.analytics as LogAnalyticsEventParams['analytics'],
      ably_only_log: logging.ably_only_log,
    });
  }, [logging, screenName]);
};
